// AboutSection.jsx - Component for Home page
import React from "react";
import { Link } from "react-router-dom";

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <img
              src="https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763411201/SSK_7159_yerbgi.jpg"
              alt="About the photographer"
              className="w-full h-auto object-cover"
            />
          </div>
          <div className="text-center md:text-left">
            <h2 className="text-3xl md:text-4xl font-extralight text-gray-900 mb-6 tracking-tight">
              ABOUT <span className="italic text-teal-600 font-light">the artist</span>
            </h2>
            <div className="flex items-center justify-center md:justify-start mb-8">
              <div className="w-16 h-px bg-teal-500"></div>
              <div className="w-2 h-2 bg-teal-500 rounded-full mx-4"></div>
              <div className="w-16 h-px bg-teal-500"></div>
            </div>
            <p className="text-gray-600 mb-6 font-light leading-relaxed">
              At Shasz Studios, we focus on capturing the essence of life's most
              beautiful moments, blending artistry and storytelling in every
              frame. With a deep passion for creating timeless images, I
              specialize in lifestyle portraits, weddings, and landscapes.
            </p>
            <p className="text-gray-600 mb-8 font-light leading-relaxed">
              Each photograph is crafted to reflect emotion and natural beauty,
              ensuring that your memories are preserved with authenticity and
              elegance. Whether it's a couple's intimate connection, the joy of
              a wedding day, or the serene beauty of a landscape, I am dedicated
              to delivering images that tell your unique story.
            </p>
            <Link 
              to="/about"
              className="group flex items-center gap-3 bg-gradient-to-r from-teal-500 to-teal-600 text-white hover:from-teal-600 hover:to-teal-700 px-8 py-4 font-light tracking-wide transition-all duration-300 text-sm w-fit mx-auto md:mx-0"
            >
              READ MORE
              <span className="group-hover:translate-x-1 transition-transform">→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
